import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Divider, FullRow, TextButton, useOverlayContext } from 'seagull';
import { Download, UserAdd } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { getAgreementPdfUrl } from '~/business-logic/relationshipLogic';
import InviteOrEditMemberModal from '~/components/InviteOrEditMemberModal';
import { useIoContext, useStore } from '~/contexts';
import { relationshipModel } from '~/models';
import { selectors } from '~/store/state-selectors';
import styles from './CoverPageHeader.module.scss';
export const GetCoverPageHeaderTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const CoverPageHeader = (param)=>{
    let { testId, relationship } = param;
    const { CoverPageHeaderTestIds } = useMemo(()=>GetCoverPageHeaderTID(testId), [
        testId
    ]);
    const { showModal } = useOverlayContext();
    const { openNewTab } = useIoContext();
    const pdfHost = useStore(selectors.pdfHost);
    const onDownloadPdf = ()=>{
        openNewTab(getAgreementPdfUrl(relationshipModel.id(relationship), pdfHost));
    };
    const openInviteMemberModal = ()=>{
        showModal({
            biName: 'invite_or_edit_member_modal',
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(InviteOrEditMemberModal, {
                    skin: "transparent",
                    isResponsive: true,
                    onClose: dismissModal
                });
            }
        });
    };
    return /*#__PURE__*/ _jsx(FullRow, {
        justifyContent: "end",
        testId: CoverPageHeaderTestIds.Root(),
        className: styles.root,
        children: /*#__PURE__*/ _jsxs(Box, {
            className: styles.container,
            children: [
                /*#__PURE__*/ _jsx(TextButton, {
                    testId: CoverPageHeaderTestIds.DownloadPdf(),
                    prefixIcon: /*#__PURE__*/ _jsx(Download, {}),
                    underline: "none",
                    onClick: onDownloadPdf,
                    weight: "normal",
                    children: "Download PDF"
                }),
                /*#__PURE__*/ _jsx(Divider, {
                    orientation: "vertical",
                    margin: 16
                }),
                /*#__PURE__*/ _jsx(TextButton, {
                    testId: CoverPageHeaderTestIds.InviteMember(),
                    prefixIcon: /*#__PURE__*/ _jsx(UserAdd, {}),
                    underline: "none",
                    onClick: openInviteMemberModal,
                    weight: "normal",
                    children: "Invite a team member"
                })
            ]
        })
    });
};
